/** @format */

export enum ConstrainedWrapperGutter {
    /**
     * Desktop: 4.8rem
     * Mobile: 2.4rem
     */
    LARGE_GUTTER = 'large-gutter',

    /**
     * Desktop: 2.4rem
     * Mobile: 1.2rem
     */
    SMALL_GUTTER = 'small-gutter',

    /**
     * Desktop: 4.8rem
     * Mobile: 1.2rem
     */
    VARIABLE_GUTTER = 'variable-gutter',
}

export enum ConstrainedWrapperSize {
    S_1248 = 's-1248',
    S_984 = 's-984',
    /**
     * @deprecated use another size instead
     */
    S_1440 = 's-1440',
    /**
     * @deprecated use another size instead
     */
    S_1280 = 's-1280',
    /**
     * @deprecated use another size instead
     */
    S_1080 = 's-1080',
    /**
     * @deprecated use another size instead
     */
    S_720 = 's-720',
    /**
     * @deprecated use another size instead
     */
    S_552 = 's-552',
    /**
     * @deprecated use another size instead
     */
    S_312 = 's-312',
}

export enum ConstrainedWrapperType {
    PADDING = 'padding',
    GRID = 'grid',
}
